import React from 'react';
import { Helmet } from 'react-helmet';

import Footer from '../../components/Footer';

import './styles.css';


const Component = () => (
  <div className="privacy_main">
    <Helmet>
        <meta name="description" content="We're transparent about what data we collect and how we use it. Feel free to ask us anytime!" />
        <title>Baloo: Privacy Policy</title>
    </Helmet>
    <div className="privacy_container">
      <div className="privacy_header">
        Privacy Policy
      </div>
      <div className="privacy_body">
        We haven’t defined our privacy policy in its entirety yet but as a socially conscious
        company we will not abuse the data you share with us.
        <br />
        <br />
        Our company is focused on aggregating individual actions at scale to better understand
        how individual actions can affect the planet. Your data will never be shared directly
        to third-parties for our financial gain.
        <br />
        <br />
        Baloo's analytics are setup with Matomo to ensure your data is secure and not being sold.
        You can learn more about how Matomo is keeping your data safe <a href="https://matomo.org/about" target="_blank">here.</a>
        <br />
        <br />
        We have taken the technical measures necessary to ensure your data is secure based
        on best security practices.
        
https://matomo.org/about/
        <br />
        <br />
        Thanks for taking the time to read our privacy policy. Once our policy is
        more clearly defined we’ll notify you so you can confirm it's up to your standards.
      </div>
    </div>
    <Footer />
  </div>
);

Component.displayName = "Privacy";

export default Component;



// WEBPACK FOOTER //
// ./src/views/Privacy/index.js